import React, { useMemo } from 'react'
import useMerchandiseCategory from 'hooks/Merchandise/useMerchandiseCategory'
import useMerchandiseCategoriesList from 'hooks/Merchandise/useMerchandiseCategoriesList'
import MerchandiseOfferCarousel from './MerchandiseOfferCarousel'
import qs from 'qs'

interface Props {
  categoryName?: string
  categoryId?: string
  trackingPageName: string
}

function MerchandiseBestOfCategoryCarousel({ trackingPageName, categoryName, categoryId }: Props) {
  const [categoriesList] = useMerchandiseCategoriesList({ name: categoryName }, { disabled: !categoryName })
  const categoryIdToUse = categoryId ?? categoriesList[0]
  const [category] = useMerchandiseCategory({ id: categoryIdToUse }, { disabled: !categoryIdToUse })

  const filters = useMemo(() => {
    if (!category) return
    return {
      categories: [category?.id]
    }
  }, [category])

  const titleConfig = useMemo<{ node: React.ReactNode; tracking: string }>(() => {
    if (!category) {
      return { node: null, tracking: '' }
    }

    switch (category.name) {
      case 'Home & Garden':
        return {
          node: <>Best of <em>{category.name}</em></>,
          tracking: `Best of ${category.name}`,
        }
      case 'Electronics':
        return {
          node: <>Top tech in <em>{category.name}</em></>,
          tracking: `Top tech in ${category.name}`,
        }
      default:
        return {
          node: <>Discover the best of <em>{category.name}</em></>,
          tracking: `Discover the best of ${category.name}`,
        }
    }
  }, [category])

  if (!category || (categoryName && category.name !== categoryName)) {
    return null
  }

  return (
    <MerchandiseOfferCarousel
      title={titleConfig.node}
      viewAllTo={`/search/shop?${qs.stringify(filters)}`}
      trackingListName={titleConfig.tracking}
      trackingPageName={trackingPageName}
      filters={filters}
    />
  )
}

export default MerchandiseBestOfCategoryCarousel
